import { render } from "./Demo.vue?vue&type=template&id=0572395a&scoped=true"
import script from "./Demo.vue?vue&type=script&lang=js"
export * from "./Demo.vue?vue&type=script&lang=js"

import "./Demo.vue?vue&type=style&index=0&id=0572395a&lang=css"
import "./Demo.vue?vue&type=style&index=1&id=0572395a&scoped=true&lang=css"

import exportComponent from "/Users/romain/Developer/vue-file-toolbar-menu/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0572395a"]])

export default __exports__